import { useState } from 'react';

import { useHistory } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app';
import { logout, selectAppDevice, selectAppState, selectAuth } from 'slice';
import { DEVICES, handleRedirectSignIn } from 'utils';

import ErrorAccessDomainDesktop from './ErrorAccessDomainDesktop';
import ErrorAccessDomainMobile from './ErrorAccessDomainMobile';

type ErrorAccessDomainProps = {
  error?: string;
  statusCode?: number;
};

const ErrorAccessDomain = ({ error, statusCode }: ErrorAccessDomainProps) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const appDevice = useAppSelector(selectAppDevice);
  const auth = useAppSelector(selectAuth);
  const app = useAppSelector(selectAppState);

  const onSignIn = async () => {
    setIsLoading(true);
    try {
      if (!auth.isLogout) {
        await dispatch(logout()).unwrap();
      }

      handleRedirectSignIn(
        history,
        '/sign-in',
        appDevice.isSpecificBrowser,
        app?.domains?.hubIdentity?.domain
      );
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log('An error occurred while logging out', err);
    } finally {
      setIsLoading(false);
    }
  };

  const onSignUp = async () => {
    setIsLoading(true);
    try {
      if (!auth.isLogout) {
        await dispatch(logout()).unwrap();
      }

      handleRedirectSignIn(
        history,
        '/sign-in',
        appDevice.isSpecificBrowser,
        app?.domains?.hubIdentity?.domain
      );
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log('An error occurred while logging out', err);
    } finally {
      setIsLoading(false);
    }
  };

  const formatProps = () => {
    return {
      error,
      onSignIn,
      onSignUp,
      isLoading,
      statusCode,
    };
  };

  const renderElements = {
    [DEVICES.DESKTOP]: <ErrorAccessDomainDesktop {...formatProps()} />,
    [DEVICES.TABLET]: <ErrorAccessDomainMobile {...formatProps()} />,
    [DEVICES.MOBILE]: <ErrorAccessDomainMobile {...formatProps()} />,
  };

  return renderElements[appDevice.device];
};

export default ErrorAccessDomain;
